import gsap from 'gsap';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

const video = document.querySelector('.rewards_video-component');

const tl = gsap.timeline(),
  mySplitText = new SplitText('.rewards_text-block', { type: 'words' }),
  { words } = mySplitText;

video?.addEventListener('canplay', () => {
  tl.to('.rewards_blur', { y: 200, duration: 0.8 }, 0.9);
  tl.from(
    words,
    {
      duration: 1,
      opacity: 0,
      y: 16,
      ease: 'power4.out',
      // stagger: 0.2,
    },
    '-=0.7'
  );
});
